import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

const ConfirmContext = createContext({
  confirm: async () => false,
});

const defaultOptions = {
  title: "Confirm Action",
  message: "Are you sure you want to continue?",
  confirmText: "Confirm",
  cancelText: "Cancel",
  tone: "dark",
};

export function ConfirmProvider({ children }) {
  const resolverRef = useRef(null);
  const [confirmState, setConfirmState] = useState(null);

  const closeConfirm = useCallback((result) => {
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
    setConfirmState(null);
  }, []);

  const confirm = useCallback((options = {}) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setConfirmState({
        ...defaultOptions,
        ...options,
      });
    });
  }, []);

  const contextValue = useMemo(() => ({ confirm }), [confirm]);

  return (
    <ConfirmContext.Provider value={contextValue}>
      {children}

      {confirmState ? (
        <div className="modal-overlay global-confirm-overlay" onClick={() => closeConfirm(false)}>
          <div className="modal modal-sm global-confirm-modal" onClick={(event) => event.stopPropagation()}>
            <h2>{confirmState.title}</h2>
            <p className="modal-message">{confirmState.message}</p>
            <div className="modal-actions">
              <button
                type="button"
                className="secondary-btn"
                onClick={() => closeConfirm(false)}
              >
                {confirmState.cancelText}
              </button>
              <button
                type="button"
                className={confirmState.tone === "danger" ? "danger-btn" : "dark-btn"}
                onClick={() => closeConfirm(true)}
              >
                {confirmState.confirmText}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  return useContext(ConfirmContext);
}
